import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { TableConstant } from '@app/constant/table.constant';
import { ITableAttributes } from '@app/interface/table.interface';
import { SharedService } from '@app/services/shared.service';
import { CommonHelper } from '@app/shared/helpers/common.helper';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-global-search-result',
  templateUrl: './global-search-result.component.html',
  styleUrls: ['./global-search-result.component.scss']
})
export class GlobalSearchResultComponent implements AfterViewInit, OnDestroy {

  public searchResult = [];
  public resultHeader = JSON.parse(JSON.stringify(TableConstant.FAILUREDASHBOARD_COLUMNS));
  public resultAttributes: ITableAttributes;
  private subscriptions: Subscription[] = [];
  constructor(private _sharedService: SharedService,
    private _cmHelper: CommonHelper,
    private location: Location) { }

  ngOnDestroy(): void {
    this.subscriptions.forEach(element => element.unsubscribe());
  }

  ngAfterViewInit(): void {
    this.subscriptions.push(
      this._sharedService.getGlobalSearchResult()
        .subscribe((result) => {
          if (this._cmHelper.isNullOrUndefined(result) && Array.isArray(result)) {
            this.searchResult = result;
            this._sharedService.setGlobalSearchResult(undefined);
          }
        }));
  }

  onBackClick(): void {
    this.location.back();
    this._sharedService.setglobalSearchPopOpenValue(true);
  }
}
